<style lang="scss" scoped>
$breakpoint-md: 576px;

.question-properties {
    opacity: 0.3;
    text-align: right;
    margin-bottom: 5px;

    .badge {
        margin-left: 10px;

        span {
            font-weight: normal;
        }
    }
}
</style>

<template>
  <div class="col-lg-4 col-md-6 mb-4">
    <div class="card h-100">
      <div class="card-body">
        <div class="question-properties">
          <b-badge v-if="item.question.vision" :title="$t('userAnswers.fields.vision')">
            <span>{{ item.question.vision | tl }}</span>
          </b-badge>
          <b-badge v-if="item.question.notion" :title="$t('userAnswers.fields.notion')">
            <span>{{ item.question.notion | tl }}</span>
          </b-badge>
          <b-badge v-if="item.question.theme" :title="$t('userAnswers.fields.theme')">
            <span>{{ item.question.theme | tl }}</span>
          </b-badge>
          <font-awesome-icon v-if="item.bookmark" :icon="['fas', 'star']" class="ml-2 text-warning"
                              v-b-tooltip.hover :title="$t('question.form.bookmark')"/>
        </div>
        <span class="font-weight-bold">{{$t('userAnswers.stats.Q')}}</span>
        <router-link
          :to="{name: 'QuestionShow', params: { id: item.question.id }}"
          v-if="owned"
        >{{ item.question.label }}</router-link>
        <span class="btn-link" v-if="!owned">{{ item.question.label }}</span>
        <div v-if="!item.isSkipped">
          <div v-if="item.answer">
            <span class="font-weight-bold">{{$t('userAnswers.stats.A')}}</span>
            {{ item.answer.label }}
          </div>
        </div>
        <div v-if="item.gaugeLevel">
          <div class="mt-2">{{$t('userAnswers.fields.gauge')}}</div>
          <b-progress :max="5" :value="item.gaugeLevel"></b-progress>
        </div>
      </div>
      <div v-if="item.isFantasy || item.isAction" class="card-footer text-center">
        <b-badge variant="info" v-if="item.isFantasy">{{$t('userAnswers.fields.fantasy')}}</b-badge>
        <b-badge variant="info" v-if="item.isAction">{{$t('userAnswers.fields.action')}}</b-badge>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    owned: {
      type: Boolean,
      default: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/userAnswer/Card.vue